import axios from 'axios'
import getHeaders from '@/api/headersSetting'

const AXIOS_PARAMS = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: getHeaders()
}

const instance = axios.create(AXIOS_PARAMS)

// GET`s
export function getActivePolicy (cpf) {
  const params = {
    url: `internal-cell-phones/v1/policy/active?cpf=${cpf}`,
    method: 'GET'
  }

  return instance(params)
}

export function getDataPolicy (uuid, token) {
  const params = {
    url: `internal-cell-phones/v1/policy/${uuid}`,
    method: 'GET'
  }

  return instance(params)
}

export async function checkPixPayment (uuid) {
  const params = {
    url: `/internal-commons/v1/payments/pixs/${uuid}`,
    method: 'GET'
  }

  return instance(params)
}

export async function updatePixQrCode (uuid) {
  const params = {
    url: `/internal-commons/v1/payments/pixs/${uuid}`,
    method: 'PUT'
  }

  return instance(params)
}

export async function getListDeviceType () {
  const params = {
    url: `internal-cell-phones/v1/devices`,
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getDevices (id) {
  const params = {
    url: `internal-cell-phones/v1/phones?deviceType=${id}`,
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getDataProduct ({ uuid, isRenovation }) {
  // const url = isRenovation
  //   ? `internal-cell-phones/v1/phones/${uuid}/net`
  //   : `internal-cell-phones/v1/phones/${uuid}`
  const url = `internal-cell-phones/v1/phones/${uuid}/net`

  const params = { url, method: 'GET' }
  const response = await instance(params)

  return response
}

export async function getPromoCode ({ uuid, promoCode, isRenovation }) {
  // const url = isRenovation
  //   ? `internal-cell-phones/v1/phones/${uuid}/promocodes/${promoCode}/net`
  //   : `internal-cell-phones/v1/phones/${uuid}/promocodes/${promoCode}`
  const url = `internal-cell-phones/v1/phones/${uuid}/promocodes/${promoCode}/net`

  const params = { url, method: 'GET' }
  const response = await instance(params)

  return response
}

export async function getPolicy ({ policyNumber, cpf, token }) {
  const params = {
    url: `internal-cell-phones/v1/policy?policyNumber=CICLI.${policyNumber}&cpf=${cpf}`,
    headers: { access_token: token },
    method: 'GET'
  }

  const response = await instance(params)

  return response
}

export async function getBanks () {
  const params = {
    url: 'internal-loans/v1/banks',
    method: 'GET'
  }

  return instance(params)
}

export async function getCampaign () {
  const configs = {
    url: 'internal-commons/v1/campaigns/celular/livelo/information',
    method: 'GET'
  }

  return instance(configs)
}

export async function getAppSettings (clientID) {
  const { groups } = /(key-(?<partner>.*)-((ex|in)ternal)-(pr(o)?d|hml|dev))|(key-(?<partner2>.*)-(pr(o)?d|hml|dev))/.exec(clientID) || {}

	const partner = (groups && (groups.partner || groups.partner2)) || 'ciclic'

  const configs = {
    url: `https://static.ciclic.com.br/data/partner/${partner}.json`,
    method: 'GET'
  }

  return instance(configs)
}

// POST`s
export async function postLead ({ cookieGA, data }) {
  const params = {
    url: '/internal-commons/v2/lead',
    ...cookieGA && { headers: { 'cookie-ga': cookieGA } },
    method: 'POST',
    data
  }

  const response = await instance(params)
  return response
}

export async function getAccessToken () {
  const environment = 'staging' || 'local'
  const data = { grant_type: 'client_credentials' }
  const Authorization = process.env.VUE_APP_ENV === environment
    ? 'Basic a2V5LWNpY2xpYy1pbnRlcm5hbC1obWw6ZWZhZmJiY2QtN2FlZi0zMDUxLTg5OGUtZmNlMzRmNzE0MGQ4'
    : 'Basic a2V5LWNpY2xpYy1pbnRlcm5hbC1wcmQ6NjY1ZDk4N2UtNmE3My0zZDUwLThkNGYtM2ViMjM1NDc1Njdl'

  const params = {
    url: '/oauth/access-token',
    headers: { Authorization },
    method: 'POST',
    data
  }

  const response = await instance(params)
  return response
}

// PATCH`s
export async function patchtLead ({ uuid, cookieGA, data }) {
  if (!uuid) return

  const params = {
    url: `/internal-commons/v2/lead/${uuid}`,
    ...cookieGA && { headers: { 'cookie-ga': cookieGA } },
    method: 'PATCH',
    data
  }

  const response = await instance(params)
  return response
}

export async function patchAutoRenewal (data) {
  const endpoint = data.autoRenewal ? 'opt-in' : 'opt-out'
  const params = {
    url: `/internal-cell-phones/v1/policies/${data.policyUuid}/${endpoint}`,
    method: 'PATCH',
    data: {
      ...(data.autoRenewal ? {} : { reason: data.reason })
    }
  }

  const response = await instance(params)
  return response
}

export async function getReasons () {
  const params = {
    url: 'internal-cell-phones/v1/renovation/opt-out-reasons',
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export default instance
